import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import moment from 'moment'
import 'moment/locale/pt-br'

import SosButton from '@/components/SosButton'
import { apiGetDeletedDutiesHistory } from '@/services/endpoints/scales'
import { getScalesByGroupID } from '@/services/firebase'

const MONTHS = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export default {
  name: 'DeletedDutiesHistory',

  components: {
    'date-picker': DatePicker,
    'sos-button': SosButton,
  },

  data () {
    const now = new Date()
    return {
      loading: false,
      scalesLoading: true,
      groupName: '',
      scaleName: '',
      entries: [],

      scales: [],       // [{ value: scaleID, text: scaleName }]
      localScaleID: null,
      filterType: 'duty', // 'duty' | 'deletion'

      actualMonth: now.getMonth(),
      actualYear: now.getFullYear(),
      yearMonth: `${MONTHS[now.getMonth()]}/${now.getFullYear()}`,

      lang: {
        formatLocale: {
          months: MONTHS,
          monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
          weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
          weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        },
        yearFormat: 'YYYY',
        monthFormat: 'MMMM',
      },
    }
  },

  computed: {
    currentMonthLabel () {
      return `${MONTHS[this.actualMonth]} de ${this.actualYear}`
    },

    scaleOptions () {
      // Prefer Vuex store (already in memory from ViewScale navigation)
      const storeScales = this.$store.state.groupScales || []
      if (storeScales.length > 0) {
        return storeScales.map(s => ({ value: s.scaleID, text: s.scaleName || s.scaleID }))
      }
      // Fall back to directly-fetched scales (direct URL access)
      return this.scales
    },

    filteredEntries () {
      return this.entries
    },

    entriesByDate () {
      const groups = {}
      this.filteredEntries.forEach(entry => {
        if (!groups[entry.date]) {
          groups[entry.date] = {
            dateFormatted: entry.dateFormatted,
            dayOfWeek: entry.dayOfWeek,
            entries: [],
          }
        }
        groups[entry.date].entries.push(entry)
      })
      return groups
    },
  },

  async mounted () {
    moment.locale('pt-BR')
    const { groupID } = this.$route.params
    const preferredScaleID = this.$route.query.scaleID || null

    // Load scale list — from store if available, otherwise directly from Firebase
    if (this.scaleOptions.length === 0) {
      const rawScales = await getScalesByGroupID(groupID)
      this.scales = rawScales.map(([scaleID, data]) => ({
        value: scaleID,
        text: (data && data.type) ? String(data.type) : scaleID,
      }))
    }

    this.scalesLoading = false

    if (this.scaleOptions.length > 0) {
      const validPreferred = preferredScaleID && this.scaleOptions.find(s => s.value === preferredScaleID)
      this.localScaleID = validPreferred ? preferredScaleID : this.scaleOptions[0].value
      await this.fetchHistory()
    }
  },

  methods: {
    async fetchHistory () {
      if (!this.localScaleID) return

      this.loading = true

      const { groupID } = this.$route.params
      const month = this.actualMonth + 1
      const year = this.actualYear

      const response = await apiGetDeletedDutiesHistory(groupID, this.localScaleID, month, year, this.filterType)

      if (response.httpCode === 200 && response.data) {
        this.groupName = response.data.groupName || ''
        this.scaleName = response.data.scaleName || ''
        this.entries   = response.data.entries   || []
      } else {
        this.entries = []
      }

      this.loading = false
    },

    onScaleChange (scaleID) {
      this.localScaleID = scaleID
      this.fetchHistory()
    },

    goBack () {
      const { groupID } = this.$route.params
      this.$router.push(`/admin/grupos/${groupID}/escalas/${this.localScaleID}`)
    },

    onFilterTypeChange (type) {
      this.filterType = type
      this.fetchHistory()
    },

    onMonthChange (value) {
      if (!value) return
      const [monthName, yearStr] = value.split('/')
      this.actualMonth = MONTHS.indexOf(monthName)
      this.actualYear = parseInt(yearStr)
      this.fetchHistory()
    },
  },
}
